var _path, _mask, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 75,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.808 49.43c2.73-.61 4.689-3.194 4.689-6.185 0-2.99-1.96-5.575-4.689-6.184-1.316-.294-2.21.84-2.21 1.867v8.635c0 1.026.894 2.16 2.21 1.867zM67.95 49.43c-2.728-.61-4.688-3.194-4.688-6.185 0-2.99 1.96-5.575 4.689-6.184 1.316-.294 2.21.84 2.21 1.867v8.635c0 1.026-.894 2.16-2.21 1.867z",
    fill: "#fff",
    stroke: "#131A4F",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "head_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 5.314,
    y: 0.273,
    width: 62,
    height: 75,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.314.273h62v75h-62z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.13 11.258l.001-.192-6.458-8.402a1 1 0 00-1.585 0l-6.458 8.402.001.192C17.71 15.138 7.314 27.096 7.314 41.245c0 17.294 12.79 31.312 28.566 31.312 15.777 0 28.567-14.019 28.567-31.312 0-14.15-10.395-26.107-21.317-29.987z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.13 11.258l.001-.192-6.458-8.402a1 1 0 00-1.585 0l-6.458 8.402.001.192C17.71 15.138 7.314 27.096 7.314 41.245c0 17.294 12.79 31.312 28.566 31.312 15.777 0 28.567-14.019 28.567-31.312 0-14.15-10.395-26.107-21.317-29.987z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.131 11.066h2v-.68l-.414-.539-1.586 1.219zm-.001.192l-2-.03-.022 1.435 1.353.48.669-1.885zm-6.457-8.594l1.586-1.219-1.586 1.219zm-1.585 0l1.585 1.219-1.585-1.22zm-6.458 8.402l-1.586-1.22-.414.54v.68h2zm.001.192l.67 1.885 1.352-.48-.022-1.436-2 .031zm12.5-.192v.162l3.999.061.001-.223h-4zm-6.043-7.183l6.458 8.402 3.171-2.438-6.458-8.402-3.171 2.438zm1.585 0a1 1 0 01-1.585 0l3.171-2.438a3 3 0 00-4.757 0l3.171 2.438zm-6.458 8.402l6.458-8.402-3.171-2.438-6.458 8.402 3.171 2.438zm.416-1.058l-.001-.161h-4l.001.223 4-.062zM9.314 41.245c0-13.199 9.76-24.47 19.986-28.102l-1.338-3.77C16.344 13.5 5.314 26.146 5.314 41.246h4zM35.88 70.557c-14.503 0-26.566-12.946-26.566-29.312h-4c0 18.221 13.516 33.312 30.566 33.312v-4zm26.567-29.312c0 16.366-12.063 29.312-26.567 29.312v4c17.05 0 30.567-15.09 30.567-33.312h-4zM42.461 13.143c10.227 3.633 19.986 14.903 19.986 28.102h4c0-15.1-11.03-27.745-22.648-31.871l-1.338 3.769z",
    fill: "#131A4F",
    mask: "url(#head_svg__a)"
  })));
}
export default __webpack_public_path__ + "072d6b8460a72533987b930bab188f00.svg";
export { SvgHead as ReactComponent };